export const flattenRoutes = (arr) => {
  const flatRoutes = arr.reduce((flat, item) => {
    const routes = item.routes ? flattenRoutes(item.routes) : [];
    return [...flat, item, ...routes];
  }, []);

  const uniquePaths = [...new Set(flatRoutes.map((item) => item.path))];
  return flatRoutes.filter((item) => uniquePaths.includes(item.path));
};
